import { cn } from '@/utils/utils';
import Link from 'next/link';

export const logoIcon = (
  <svg
    width="28"
    height="28"
    viewBox="0 0 300 300"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="300" height="300" rx="88" fill="#FF7A00" />
    <path
      d="M200.761 66.0399C200.761 96.9545 192.843 135.059 180.588 160.268C167.605 187.02 149.702 217.353 126.938 213.394C102.777 209.173 105.339 178.054 107.842 162.422C123.765 160.559 138.233 151.681 150.11 136.311C158.348 125.657 180.85 84.8448 155.699 68.1067C134.769 54.1922 115.818 77.6838 103.767 100.302C97.5084 112.062 92.5888 124.376 89.0374 137.097C80.7702 134.768 71.6589 124.056 85.9809 91.511L64.7599 80.915C40.133 135.263 66.7975 156.222 84.1761 160.414C74.4534 224.31 112.238 237.555 131.218 237.555C168.041 237.555 194.298 187.195 200.79 168.972V235.575H224.514V66.0399H200.761ZM143.211 88.2507C147.403 90.4339 137.098 126.064 114.014 136.398C117.274 124.376 137.039 85.0486 143.211 88.2507Z"
      fill="white"
    />
  </svg>
);

const Logo = ({
  href,
  className,
  onClick,
}: {
  href?: string;
  className?: string;
  onClick?: () => void;
}) => {
  const renderLogo = () => {
    return (
      <>
        <svg
          className=" w-[64px]"
          xmlns="http://www.w3.org/2000/svg"
          width={487}
          height={138}
          viewBox="0 0 487 138"
          fill="none"
        >
          <path
            fill="#000"
            d="M432.758 137.312c-7.965 0-14.581-1.348-19.848-4.046-5.268-2.698-9.186-6.295-11.755-10.792-2.57-4.496-3.854-9.378-3.854-14.645 0-6.167 1.541-11.498 4.625-15.994 3.211-4.497 7.9-7.965 14.067-10.406 6.166-2.57 13.746-3.855 22.739-3.855h24.473c0-5.138-.706-9.378-2.12-12.718-1.413-3.468-3.597-6.038-6.551-7.708-2.955-1.67-6.745-2.505-11.37-2.505-5.267 0-9.764 1.22-13.489 3.661-3.726 2.313-6.038 5.91-6.937 10.792h-22.739c.77-6.938 3.083-12.847 6.937-17.73 3.854-5.01 8.928-8.863 15.223-11.561 6.424-2.827 13.425-4.24 21.005-4.24 9.121 0 16.894 1.606 23.317 4.818 6.424 3.083 11.305 7.58 14.646 13.49 3.468 5.78 5.202 12.782 5.202 21.004V135h-19.655l-2.313-15.609c-1.284 2.569-2.954 4.946-5.01 7.13-1.927 2.184-4.175 4.111-6.744 5.781-2.57 1.542-5.525 2.762-8.865 3.662-3.212.899-6.873 1.348-10.984 1.348Zm5.203-18.306c3.726 0 7.002-.643 9.828-1.927 2.955-1.414 5.46-3.341 7.515-5.781 2.184-2.57 3.854-5.396 5.011-8.479 1.156-3.084 1.927-6.36 2.312-9.828v-.386h-21.39c-4.496 0-8.222.578-11.177 1.735-2.955 1.027-5.074 2.57-6.359 4.625-1.285 2.055-1.927 4.432-1.927 7.13 0 2.697.642 5.01 1.927 6.937 1.285 1.927 3.148 3.404 5.588 4.432 2.441 1.028 5.332 1.542 8.672 1.542ZM335.354 135V37.878h20.619l2.12 18.114c2.313-4.24 5.203-7.837 8.672-10.791 3.468-3.084 7.515-5.46 12.14-7.13 4.753-1.67 9.956-2.506 15.609-2.506V60.04h-8.093c-3.855 0-7.516.513-10.985 1.541-3.468.9-6.487 2.441-9.057 4.625-2.441 2.056-4.368 4.946-5.781 8.672-1.413 3.597-2.119 8.157-2.119 13.682V135h-23.125ZM268.637 137.312c-7.965 0-14.581-1.348-19.849-4.046-5.267-2.698-9.185-6.295-11.754-10.792-2.57-4.496-3.854-9.378-3.854-14.645 0-6.167 1.541-11.498 4.624-15.994 3.212-4.497 7.901-7.965 14.068-10.406 6.166-2.57 13.746-3.855 22.739-3.855h24.473c0-5.138-.707-9.378-2.12-12.718-1.413-3.468-3.597-6.038-6.552-7.708-2.954-1.67-6.744-2.505-11.369-2.505-5.267 0-9.764 1.22-13.489 3.661-3.726 2.313-6.038 5.91-6.938 10.792h-22.739c.771-6.938 3.084-12.847 6.938-17.73 3.854-5.01 8.928-8.863 15.223-11.561 6.424-2.827 13.425-4.24 21.005-4.24 9.121 0 16.893 1.606 23.317 4.818 6.423 3.083 11.305 7.58 14.645 13.49 3.469 5.78 5.203 12.782 5.203 21.004V135h-19.655l-2.313-15.609c-1.285 2.569-2.955 4.946-5.01 7.13-1.927 2.184-4.175 4.111-6.745 5.781-2.569 1.542-5.524 2.762-8.864 3.662-3.212.899-6.873 1.348-10.984 1.348Zm5.203-18.306c3.725 0 7.001-.643 9.828-1.927 2.954-1.414 5.46-3.341 7.515-5.781 2.184-2.57 3.854-5.396 5.01-8.479 1.157-3.084 1.927-6.36 2.313-9.828v-.386h-21.39c-4.497 0-8.222.578-11.177 1.735-2.955 1.027-5.074 2.57-6.359 4.625-1.285 2.055-1.927 4.432-1.927 7.13 0 2.697.642 5.01 1.927 6.937 1.285 1.927 3.147 3.404 5.588 4.432 2.441 1.028 5.332 1.542 8.672 1.542ZM131.526 135V37.878h20.426l1.735 16.187c2.954-5.653 7.194-10.15 12.718-13.49s12.076-5.01 19.656-5.01c7.836 0 14.517 1.67 20.041 5.01 5.524 3.212 9.764 7.966 12.718 14.26 3.084 6.296 4.625 14.132 4.625 23.51V135h-23.124V80.465c0-8.093-1.799-14.324-5.396-18.692s-8.928-6.552-15.994-6.552c-4.625 0-8.8 1.092-12.526 3.276-3.597 2.184-6.488 5.396-8.672 9.635-2.055 4.111-3.083 9.121-3.083 15.03V135h-23.124ZM.818 135 50.15.108h25.822L125.304 135H100.83L62.868 27.086 24.905 135H.818Zm21.968-31.796 6.166-18.307h66.483l6.166 18.307H22.786Z"
          />
        </svg>
      </>
    );
  };

  return href ? (
    <Link
      href={href}
      className={cn(
        'flex flex-row justify-start items-center gap-2 p-2 -m-2 cursor-pointer',
        className,
      )}
      {...(onClick && { onClick })}
    >
      {renderLogo()}
    </Link>
  ) : (
    <div
      className={cn(
        'flex flex-row justify-start items-center gap-2 p-2 -m-2 cursor-pointer',
        className,
      )}
    >
      {renderLogo()}
    </div>
  );
};

export default Logo;
